module.exports = __webpack_public_path__ + "static/media/teste.6490afc0.ico";